import { post, get } from '../../../../services/request';

// Get Site Profile Data by ID
export const getSiteProfileData = (siteID) => {
    return get(`SiteManagement/GetSitesBasicInformationByID?SiteID=${siteID}`);
};

// Get Site Coverage Hours Data by ID
export const getSiteCoverageHoursData = (siteID) => {
    return get(`SiteManagement/GetSitesCoverageHours?SiteID=${siteID}`);
};

// Get Site Associated Radiologists Data by ID
export const getSiteAssociatedRadsData = (siteID) => {
    return get(`SiteManagement/GetSitesAssociatedRads?SiteID=${siteID}`);
};

// Get Site Calendar Demand Data
export const getSiteCalendarDemandData = (siteID, demandDate) => {
    //return get(`SiteManagement/GetSitesCalenderDemand?SiteID=${siteID}&DemandDate=${demandDate}`);
    return get(`SiteManagement/GetSitesCalenderDemand?SiteID=${siteID}&DemandDate=${demandDate}`);
};

// Get Site Calendar Demand By Date Data
export const getSiteCalendarDemandByDateData = (siteId, demandDate) => {
    return get(`SiteManagement/GetSiteCalendarDemandByDate?SiteID=${siteId}&DemandDate=${demandDate}`);
};

// Get Site RADS Demand Schedule Data
export const getSiteRadsDemandScheduleData = (siteId, demandDate, demandTime) => {
    const encodedDemandTime = encodeURIComponent(demandTime);
    return get(`SiteManagement/GetSiteRadsDemandSheduleInfo?SiteID=${siteId}&DemandDate=${demandDate}&DemandTime=${encodedDemandTime}`);
};

// Get Site Associated RAD Metrics Data
export const getSiteAssociatedRadMetricsData = (payload) => {
    // If payload is just a siteID, convert to proper payload structure
    if (typeof payload === 'string' || typeof payload === 'number') {
        const today = new Date();
        const fromDate = new Date(today.getTime() - 83 * 24 * 60 * 60 * 1000);
        const toDate = new Date(today.getTime() - 24 * 60 * 60 * 1000);
        
        const formatDate = (date) => {
            const mm = String(date.getMonth() + 1).padStart(2, '0');
            const dd = String(date.getDate()).padStart(2, '0');
            const yyyy = date.getFullYear();
            return `${mm}/${dd}/${yyyy}`;
        };
        
        payload = {
            SiteID: payload,
            FromDate: formatDate(fromDate),
            ToDate: formatDate(toDate),
            RadiologistID: null,
            PriorityID: "",
            ModalityId: "", 
            Status: "",
            StudyWithInCoverage: ""
        };
    }
    
    return post(`SiteManagement/GetRadMatrixDetails`, payload);
};

// Get Site RAD Metrics Dropdown Data
export const getSiteRadMetricsDropdownData = (payload) => {
    return post(`Radiologist/GetRadSiteMatrixDropdown`, payload);
};

// Export Site Associated RAD Metrics Data
export const exportSiteAssociatedRadMetricsData = (payload) => {
    return post(`SiteManagement/ExportRadMatrix`, payload);
};

// Get Site Matrix Child Tables Data
export const getSiteMatrixChildTablesData = (payload) => {
    return post(`Radiologist/GetSiteMatrixChildTables`, payload);
};

// Get Site Profile Demand By Hours Chart Data
export const getSiteProfileDemandByHoursChartData = (payload) => {
    return post(`SiteManagement/GetSiteProfileDemandByHoursChart`, payload);
};

// Get Site Profile Volume By Priority Chart Data
export const getSiteProfileVolumeByPriorityChartData = (payload) => {
    return post(`SiteManagement/GetSiteProfileVolumeByPriorityChart`, payload);
};

export const getSiteProfileVolumeByModalityChartData = (payload) => {
    return post('SiteManagement/GetSiteProfileVolumeByModalityChart', payload);
};

// Get Site Profile Metrics Dropdown (for filter dropdowns on chart tabs)
export const getSiteProfileMetricsDropdownData = () => {
    return post(`SiteManagement/GetSiteProfileMetricsDropdown`, {});
};

// Get Site Profile Demand By Hours Chart Details (Filtered)
export const getSiteProfileDemandByHoursChartDetailsData = (payload) => {
    return post(`SiteManagement/GetSiteProfileDemandByHoursChartDetails`, payload);
};

// Get Site Profile Volume By Modality Chart Details (Filtered)
export const getSiteProfileVolumeByModalityChartDetailsData = (payload) => {
    return post(`SiteManagement/GetSiteProfileVolumeByModalityChartDetails`, payload);
};

// Get Site Profile Volume By Priority Chart Details (Filtered)
export const getSiteProfileVolumeByPriorityChartDetailsData = (payload) => {
    return post(`SiteManagement/GetSiteProfileVolumeByPriorityChartDetails`, payload);
};

// Associate RAD to Site
export const associateRadToSite = (payload) => {
    return post('RadCredential/AssociateRadToSite', payload);
};

// Disassociate RAD from Site
export const disassociateRadFromSite = (payload) => {
    return post('RadCredential/DisassociateRadFromSite', payload);
};

// Get RADs not associated to Site (for the Add modal dropdown)
export const getRadsNotAssociatedToSite = (siteId) => {
    return get(`RadCredential/GetRadsNotAssociatedToSite?siteID=${siteId}`);
};

// Site Rad Assignment Notes
export const getSiteRadNotes = (payload) => {
    return get(`RadSiteAssignmentNotes/GetRadSiteAssignmentNotesByID?radiologistSiteAssignmentID=${payload.radiologistSiteAssignmentId}`);
};

export const getSiteLicenseAndRadSiteAssignmentNotes = (payload) => {
    return get(`RadSiteAssignmentNotes/GetLicenseAndRadSiteAssignmentNotesByProviderId?radiologistID=${payload.radiologistID}`);
};

export const addSiteRadNote = (payload) => {
    return post('RadSiteAssignmentNotes/AddRadSiteAssignmentNote', payload);
};
